const config = {
  apiKey: 'AIzaSyC_OPbE3qTl6hiRbrEnVe6SNImK_ShxQ04',
  authDomain: 'sourceqr-dev.firebaseapp.com',
  databaseURL: 'https://sourceqr-dev.firebaseio.com',
  projectId: 'sourceqr-dev',
  storageBucket: 'sourceqr-dev.appspot.com',
  messagingSenderId: '1077930424323',
  appId: '1:1077930424323:web:cda6c2f849032f90',
  functionsURL: 'http://localhost:5000/sourceqr-dev/us-central1/app/api',
  //functionsURL: 'https://ownerfy.ngrok.io/sourceqr-dev/us-central1/app/api',
  //functionsURL: 'https://dev.ownerfy.io/api',
  //registrationBase: 'https://dev.ownerfy.io/product-registration/register',
  registrationBase: 'http://localhost:3000/reg',
  //functionsURL: 'https://us-central1-sourceqr-dev.cloudfunctions.net/app/api',
  ga: 'UA-158644940-1',
  stripe: 'pk_test_LyYoI8QT9gxmX4PPtiK4pa1500L9wjEm2L',
  shopifyAPIKey: 'd3c32d2803e3472b7fedb82c20ca339a',
};

export default config;
